export default __webpack_public_path__ + "static/cloudfront-87c4239740abd14e2c51ca6376ac94d6.png";